<template>
  <div>
    <McContactTable
      :apiClient="query"
      :fields="fields"
      :hasData="hasData"
      :listDatas="employeesList"
      :withCard="false"
      :cardPadding="false"
      :hasEmptyState="false"
      :bulkCreate="isAdding"
      :dataStore="$store.state.dashboard.contactList"
      @customTag="addTag"
      @updateCountryCode="updateCountryCode"
    />
  </div>
</template>

<script>
import {
  GET_CONTACTS,
  GET_CONTACT,
  CREATE_CONTACT,
  UPDATE_CONTACT,
  DELETE_CONTACT,
} from '@/services/api/notification/contact'
import { GET_EMPLOYEES_PAGINATED } from '@/services/api/master/employees'
import McContactTable from '@/components/McContactTable'
import { mapGetters } from 'vuex'

export default {
  components: {
    McContactTable,
  },

  props: ['isAdding'],

  data() {
    return {
      countryCode: '+62',
      hasData: true,
      employeesList: [],
      render: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          name: 'user',
          key: 'user.fullname',
          label: this.$t('notification.setting.emailNotification.recipientName'),
          placeholder: this.$t('notification.setting.emailNotification.recipientName'),
          isEditable: true,
          type: 'select-resourceful-v2',
          optionsGetter: this.resourcefulQuery.employees,
          trackBy: 'userId',
          optionLabelFn: ({ item }) => item.fullname ?? item.label,
          multiple: false,
          taggable: true,
          thStyle: 'width: 300px; min-width: 200px',
          customColumn: true,
          validationBehavior: 'blur',
          errorBehavior: 'blur',
        },
        {
          name: 'phoneNumber',
          key: 'phoneNumber',
          label: this.$t('notification.setting.emailNotification.whatsappNo'),
          placeholder: this.$t('notification.setting.emailNotification.whatsappNo'),
          type: 'phone-number',
          isEditable: true,
          validation: [['isPhoneNumber', this.countryCode]],
          customColumn: true,
          validationBehavior: 'blur',
          errorBehavior: 'blur',
          disabled: this.hasWhatsapp,
          thStyle: 'width: 400px; min-width: 300px',
        },
        {
          name: 'email',
          key: 'email',
          label: this.$t('notification.setting.emailNotification.email'),
          placeholder: this.$t('notification.setting.emailNotification.email'),
          isEditable: true,
          type: 'text',
          thStyle: 'width: 300px; min-width: 200px',
          validation: 'optional|email',
          validationBehavior: 'blur',
          errorBehavior: 'blur',
        },
      ]
    },

    contactLists() {
      return this.$store.state.dashboard.contactList
    },

    query() {
      if (this.isAdding) {
        return {
          get: async () => {
            let dataState = this.contactLists
            dataState.map((item, index) => {
              return {
                ...item,
                phoneNumber: item.phoneNo,
                contactId: index + 1,
              }
            })
            if (dataState) {
              return {
                data: dataState.map((item, index) => {
                  return {
                    ...item,
                    phoneNumber: item.phoneNo,
                    contactId: index + 1,
                  }
                }),
                pagination: {
                  page: 1,
                  total: dataState.length,
                  show: 10,
                },
              }
            } else {
              return {
                data: [],
                pagination: {
                  page: 1,
                  total: 0,
                  show: 10,
                },
              }
            }
          },
          getById: async (id) => {
            const allData = this.contactLists
            const getById = allData.filter((el) => el.contactId == id)

            return {
              isSuccessful: true,
              contact: {
                ...getById[0],
              },
            }
          },

          store: async (obj) => {
            const allData = this.$store.state.dashboard.contactList
            let isDuplicateContact = []
            let isDuplicateEmail = []
            if (allData) {
              if (obj.phoneNo !== undefined)
                isDuplicateContact = allData.filter((el) => el.phoneNumber == obj.phoneNo)
              if (obj.email !== undefined)
                isDuplicateEmail = allData.filter((el) => el.email == obj.email)
            }

            if (isDuplicateContact.length > 0) {
              return this.$mcToast.warning(this.$t('dashboard.scheduler.text.duplicatedContact'))
            }

            if (isDuplicateEmail.length > 0) {
              return this.$mcToast.warning(
                this.$t('notification.setting.emailNotification.duplicatedEmail')
              )
            }

            const dataCreated = {
              contactId: obj.contactId,
              email: obj.email,
              label: obj.fullname,
              phoneNumber: obj.phoneNo,
              user: {
                fullname: obj.fullname,
                userId: obj.userId,
              },
              userId: obj.userId,
            }

            this.$store.commit('dashboard/ADD_CONTACT', dataCreated)
            const created = {
              isSuccessful: true,
              createContact: {
                ...dataCreated,
              },
            }

            return created
          },

          update: async (contactId, item, obj) => {
            const allData = this.contactLists
            let isDuplicateContact = []
            let isDuplicateEmail = []
            if (allData) {
              if (obj.phoneNo !== undefined)
                isDuplicateContact = allData.filter(
                  (el) => el.phoneNo == obj.phoneNo && el.contactId != contactId
                )
              if (obj.email !== undefined)
                isDuplicateEmail = allData.filter(
                  (el) => el.email == obj.email && el.contactId != contactId
                )
            }
            if (isDuplicateContact.length > 0) {
              return this.$mcToast.warning(this.$t('dashboard.scheduler.text.duplicatedContact'))
            }

            if (isDuplicateEmail.length > 0) {
              return this.$mcToast.warning(
                this.$t('notification.setting.emailNotification.duplicatedEmail')
              )
            }
            this.$store.commit('dashboard/UPDATE_CONTACT', item)
            const updated = {
              isSuccessful: true,
              updateContact: {
                contactId: contactId,
                email: item.email,
                label: item.fullname,
                phoneNumber: item.phoneNumber,
                user: {
                  fullname: item.fullname,
                  userId: item.userId,
                },
                userId: item.userId,
              },
            }

            return updated
          },
          delete: async (contactId) => {
            this.$store.commit('dashboard/DELETE_CONTACT', contactId)
            const deleted = {
              isSuccessful: true,
              deleteContact: {
                contactId: contactId,
              },
            }

            return deleted
          },
        }
      } else {
        return {
          get: async (filter) => {
            const res = await this.$apollo.query({
              query: GET_CONTACTS,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  ...filter,
                  reportSchedulerId: [Number(this.$route.params.id)],
                },
              },
            })

            const self = this
            if (res.data.contacts.contacts) self.hasData = true
            else self.hasData = false

            return res.data.contacts.contacts
          },
          getById: async (id) => {
            const res = await this.$apollo.query({
              query: GET_CONTACT,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  contactId: +id,
                },
              },
            })

            return res.data.contact
          },

          store: async (item, obj) => {
            let user = {}

            if (item.user) {
              if (item.user == 9999999) {
                user = {
                  label: obj.label,
                  userId: null,
                }
              } else {
                user = {
                  userId: obj.userId,
                  label: null,
                }
              }
            } else {
              user = { userId: null, label: null }
            }

            let input = {
              ...user,
              reportSchedulerId: Number(this.$route.params.id),
              phoneNumber: item.phoneNumber ? this.countryCode.slice(1) + item.phoneNumber : null,
              email: item.email ?? null,
            }

            const res = await this.$apollo.mutate({
              mutation: CREATE_CONTACT,
              variables: {
                input: input,
              },
            })

            return res.data.createContact
          },

          update: async (contactId, item, obj) => {
            let user = {}

            if (item.user) {
              if (item.user == 9999999) {
                user = {
                  label: obj.label,
                  userId: null,
                }
              } else {
                user = {
                  userId: obj.userId,
                  label: null,
                }
              }
            } else {
              user = { userId: null, label: null }
            }

            let input = {
              ...user,
              phoneNumber: item.phoneNumber ? this.countryCode.slice(1) + item.phoneNumber : null,
              email: item.email ?? null,
              contactId: +contactId,
              reportSchedulerId: Number(this.$route.params.id),
            }

            const res = await this.$apollo.mutate({
              mutation: UPDATE_CONTACT,
              variables: {
                input: input,
              },
            })

            return res.data.updateContact
          },
          delete: async (contactId) => {
            const res = await this.$apollo.mutate({
              mutation: DELETE_CONTACT,
              variables: {
                input: {
                  contactId: +contactId,
                },
              },
            })

            return res.data.deleteContact
          },
        }
      }
    },

    resourcefulQuery() {
      return {
        employees: async (opts) => {
          let result = {}
          let employeeList = this.employeesList

          if (opts?.page === 1) employeeList = []

          const filter = {
            pagination: {
              page: opts?.page,
              show: opts?.limit,
            },
            search: opts?.search,
          }

          const res = await this.$apollo.query({
            query: GET_EMPLOYEES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })

          const employees = res.data.employeesPaginated.employeesPaginated

          const self = this
          employees.data.map((item) => employeeList.push(item))

          self.employeesList = employeeList

          result = {
            metadata: {
              total_count: employees.pagination.total,
              page: employees.pagination.page,
            },
            data: {
              paginated_result: employees.data,
            },
          }

          return result
        },
      }
    },

    hasWhatsapp() {
      const disabled = this.hasAccessAll(['whatsapp-integration:read'])
      return !disabled
    },
  },

  watch: {
    countryCode: {
      handler(value) {
        if (value) {
          if (value.includes('+')) this.countryCode = value
          else this.countryCode = `+${value}`
        } else this.countryCode = '+62'
      },
    },
  },

  methods: {
    updateCountryCode(value) {
      this.countryCode = value
    },

    addTag(obj) {
      this.employeesList.push(obj)
    },
  },
}
</script>
